import { effects } from 'redux-saga'

/**
 * Handles an ApiError, which is just a response from the API base class which
 * contains the error, response and json parsed response.
 */
export default function* handleViolations(apiError, actionCreator) {
  if (!apiError.json || !Object.prototype.hasOwnProperty.call(apiError.json, 'violations')) {
    throw apiError
  }

  yield effects.put.resolve(actionCreator(apiError.json.violations))
}




// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/effects/handleViolations.js